import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { FC, useCallback, useEffect, useState } from "react";
import {
  Localizacao,
  createLocalizacao,
  deleteLocalizacao,
  getLocalizacoes,
  updateLocalizacao,
} from "src/apis/eezyfamily";
import PageContainer from "src/pages/components/PageContainer";
import { isUserAdministrator } from "src/utils/auth";
import LocalizacoesTable from "./components/LocalizacoesTable";
import LocalizacaoModal from "./components/LocalizacaoModal";

const EFLocalizacoesPage: FC = (): JSX.Element => {
  const [entries, setEntries] = useState<Localizacao[]>([]);
  const [error, setError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editTarget, setEditTarget] = useState<Localizacao | null>(null);

  const load = useCallback(async () => {
    try {
      const data = await getLocalizacoes();
      setEntries(data);
      setError("");
    } catch (err: any) {
      setError(err?.message ?? "Erro ao carregar localizações.");
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleEdit = (item: Localizacao) => {
    setEditTarget(item);
    setModalOpen(true);
  };

  const handleAdd = () => {
    setEditTarget(null);
    setModalOpen(true);
  };

  const handleDelete = async (id: number) => {
    if (
      !window.confirm(
        "Tem certeza que deseja excluir esta localização? Esta ação não pode ser desfeita."
      )
    )
      return;
    try {
      await deleteLocalizacao(id);
      setEntries((prev) => prev.filter((e) => e.id !== id));
    } catch (err: any) {
      setError(err?.message ?? "Erro ao excluir.");
    }
  };

  const handleSaved = () => {
    setModalOpen(false);
    load();
  };

  return (
    <PageContainer title="Localizações" error={error} guard={isUserAdministrator}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAdd}
        >
          Adicionar Localização
        </Button>
      </Box>

      <LocalizacoesTable
        localizacoes={entries}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <LocalizacaoModal
        open={modalOpen}
        editTarget={editTarget}
        onClose={() => setModalOpen(false)}
        onSaved={handleSaved}
        onCreate={createLocalizacao}
        onUpdate={updateLocalizacao}
      />
    </PageContainer>
  );
};

export default EFLocalizacoesPage;
